import React, { useContext, useEffect, useState } from 'react';
import styles from '../../css/components/toasts/toasts.css';
import PropTypes from 'prop-types';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';

function Toast({
	messageType,
	messageHeadline = '',
	messageContent = '',
	closeCallback = null,
	life = 5000,
	verticalOrder = 1,
	showReloadPageLink = false
}) {
	const [isShown, setIsShown] = useState(true);

	const onelpsParams = useContext(OneLPSsdkParamsContext);

	const onCloseClickCallback = () => {
		if (closeCallback) {
			closeCallback();
		}
		setIsShown(false);
	};

	useEffect(() => {
		const timeout = setTimeout(() => {
			onCloseClickCallback();
		}, life);

		return () => clearTimeout(timeout);
	}, []);

	return (
		isShown && (
			<section
				className={`${styles.toast} ${styles[messageType]} ${styles[onelpsParams.gameId]}`}
				style={{ top: `${verticalOrder * 75}px` }}
			>
				<aside></aside>
				<main>
					<h1>{messageHeadline}</h1>
					<p>{messageContent}</p>
					{messageType === 'support' && (
						<a
							href={`https://support.innogames.com/landing/${onelpsParams.gameId}`}
							target='_blank'
							rel="noreferrer">Link
						</a>
					)}
					{showReloadPageLink && (
						<p className={styles.reloadpagewrapper}>
							<a
								href="/"
								onClick={(e) => { e.preventDefault(); window.location.reload(); }}>
								Reload page
							</a>
						</p>
					)}
				</main>
				<button
					onClick={() => onCloseClickCallback()}
				>
				</button>
			</section>
		)
	);

}

export default Toast;

Toast.propTypes = {
	messageType: PropTypes.oneOf(['success', 'error', 'support']).isRequired,
	messageHeadline: PropTypes.string,
	messageContent: PropTypes.string,
	closeCallback: PropTypes.func,
	life: PropTypes.number,
	verticalOrder: PropTypes.number,
	showReloadPageLink: PropTypes.bool
};